import React, { FC, ReactNode } from 'react';
import styled from 'styled-components';
import {
  Button,
  propStyling,
  PropsWithPropStyling,
  Text,
  tombac,
} from 'tombac';
import { LimitsIcon } from 'tombac-icons';

export type TrialBoxProps = PropsWithPropStyling<{
  button?: ReactNode;
  primaryText?: ReactNode;
  secondaryText?: ReactNode;
}>;

export interface TrialBoxContactButtonProps {
  moveUrl: string;
}

const Container = styled.div<PropsWithPropStyling>`
  all: initial;
  align-items: center;
  background-color: ${tombac.color('alert', 200)};
  display: flex;
  padding: ${tombac.space(2, 3)};
  ${propStyling}
`;

const Content = styled.div`
  flex: auto;
  padding: ${tombac.space(0, 2)};
`;

const TrialIcon = styled(LimitsIcon)`
  color: ${tombac.color('alert', 500)};
  height: ${tombac.unit(32)};
  width: ${tombac.unit(32)};
`;

export const TrialBoxContactButton: FC<TrialBoxContactButtonProps> = ({
  moveUrl,
}) => (
  <Button
    as="a"
    href={`${moveUrl}/dashboard/contact`}
    size="s"
    target="_blank"
    variant="alert"
  >
    Contact us
  </Button>
);

export const TrialBox: FC<TrialBoxProps> = ({
  button,
  primaryText = 'You are currently using a trial version.',
  secondaryText = 'Contact us to upgrade to full version',
  ...rest
}) => (
  <Container {...rest}>
    <TrialIcon />
    <Content>
      {primaryText && (
        <Text as="div" fontSize={12} fontWeight={500}>
          {primaryText}
        </Text>
      )}
      {secondaryText && (
        <Text as="div" fontSize={12} fontWeight={500} variant="secondary">
          {secondaryText}
        </Text>
      )}
    </Content>
    {button}
  </Container>
);
